export default __webpack_public_path__ + "static/media/190629_190332_IMG_3806.eb43c6ee.jpg";